<template>
  <realTime></realTime>
</template>

<script>
  import realTime from '@/components/realTime'
  export default {
    data(){
      return {
        
      }
    },
  // 注册组件
  components: {
    realTime
  }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/realTime/index.vue